<template lang="html">
  <div class="onboarding-guide">
    <Guide
      :content="content"
      :contentVideo="contentVideo"
      contentHeading="Website Settings"
      :closeLink="closeLink"
      :nextLink="nextLink"
      :previousLink="previousLink"/>
  </div>
</template>

<script>
import Guide from '@/components/Guide'

export default {
  name: 'OnboardingSettings',

  components: {
    Guide
  },

  props: {
    siteId: String,
    companyId: String
  },

  computed: {
    closeLink() {
      return {
        name: 'site',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    previousLink() {
      return {
        name: 'onboarding-pages',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    nextLink() {
      return {
        name: 'onboarding-themes',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    content() {
      return `
        <p>Configure your site options using the website settings panel. You can control public access by adding your domain name and toggling the lock screen.</p>

        <p>You can also upload your logo, activate Google analytics, control how your site looks in search engine listings and more!</p>
        `
    },

    contentVideo() {
      return 'https://cdn.shopify.com/assets2/home/manage-animation-a9cecf49c4414fd02d9fa00482fd30e436fc373208255d90d92491be650b8d13.mp4'
    }
  }
}
</script>
